export default {"src":"/_next/static/media/DataDog.0ee2b361.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};